import { render, staticRenderFns } from "./business.vue?vue&type=template&id=dfbbe09c&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports